'use client'

import type { LanguageSwitcherProps } from '@/components/language-switcher/language-switcher.types'

import { useTranslations } from 'next-intl'

import { useLanguageSwitcher } from '@/components/language-switcher/batons/use-language-switcher'
import Select from '@pearlconvert/ui/components/select/select'

const LanguageSwitcher = (props: LanguageSwitcherProps) => {
  const { showLabel = false, label, size = 'normal' } = props
  const { options, initialSelectedOption, handleLanguageChange } =
    useLanguageSwitcher()
  const t = useTranslations('project-scope')

  return (
    <div className="language-switcher">
      <Select
        name="language-switcher"
        size={size}
        label={label ?? t('language-switcher.label')}
        showLabel={showLabel}
        options={options}
        initialSelectedOption={initialSelectedOption}
        handleChange={handleLanguageChange}
      />
    </div>
  )
}

export default LanguageSwitcher
